import React from 'react';

const CustomCheckbox = ({ id, value, onChange }) => {
	return (
		<input
			id={id}
			style={{
				width: '20px',
				height: '20px',
			}}
			type="checkbox"
			checked={value}
			onChange={(e) => onChange(e.target.checked)}
		/>
	);
};

export default CustomCheckbox;
